import Link from 'next/link';
import { FC } from 'react';
import { Image } from 'atoms/Image/Image';
import { Body } from 'atoms/Typography/Typography';
import { SocialLinks } from 'organisms/Footer/SocialLinks';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';
import styles from './styles.module.css';

export const Payment: FC = () => {
  const { footer } = useSiteConfig();
  const paymentMain = footer?.payment_main_image?.[0];
  const paymentMethods = footer?.payment_methods?.[0];
  const isPaymentMainVisible =
    paymentMain?.text || paymentMain?.image?.filename;
  const isPaymentMethodsVisible =
    paymentMethods?.methods || paymentMethods?.title;

  return !isPaymentMainVisible && !isPaymentMethodsVisible ? null : (
    <div className={styles.root}>
      <SocialLinks />
      {isPaymentMainVisible && (
        <Link
          href={paymentMain.parameters?.url}
          target={paymentMain.parameters?.target}
          className={styles.link}
        >
          <Image
            src={paymentMain.image?.filename}
            className={styles.imageLink}
            alt={paymentMain.image?.filename}
          />
        </Link>
      )}
      {paymentMethods?.title && (
        <Body tag="h4" type="lg" className={styles.title}>
          {paymentMethods.title}
        </Body>
      )}
      <ul className={styles.list}>
        {paymentMethods?.methods?.map(({ id, filename, alt }) => (
          <li className={styles.item} key={id}>
            <Image src={filename} alt={alt} className={styles.image} />
          </li>
        ))}
      </ul>
    </div>
  );
};
